import { TOAST_TYPE } from "../../constants";
import {
  CUSTOMER_HOME_ROUTES,
  CUSTOMER_PROJECT_ROUTES,
} from "../../constants/customerApiRoutes";
import { getCookie, showToastMessage } from "../../utils";
import API from "../axios";

export const getProjectDetails = async (
  projectId: string,
  handleData: CallableFunction,
  handleLoading: CallableFunction
) => {
  try {
    const response = await API.get(
      `${CUSTOMER_HOME_ROUTES.GET_PROJECTS}/${projectId}`
    );
    handleData(response?.data?.data);
  } catch (error: any) {
    showToastMessage(
      TOAST_TYPE.ERROR,
      error?.response?.data?.message ?? error?.message
    );
  } finally {
    handleLoading(false);
  }
};

export const getSingleProjectDetails = async (
  projectId: string,
  handleData: CallableFunction,
  handleLoading: CallableFunction
) => {
  try {
    const userUuid = getCookie("userUuid");
    const response = await API.get(
      `${CUSTOMER_HOME_ROUTES.SINGLE_PROJECTS}/${projectId}?uuid=${userUuid}`
    );
    handleData(response?.data?.data);
  } catch (error: any) {
    showToastMessage(
      TOAST_TYPE.ERROR,
      error?.response?.data?.message ?? error?.message
    );
  } finally {
    handleLoading(false);
  }
};

export const saveProject = async (
  projectId: string,
  handleLoading: CallableFunction,
  callback: CallableFunction
) => {
  try {
    const response = await API.post(
      `${CUSTOMER_PROJECT_ROUTES.SAVE_PROJECT}/${projectId}`
    );
    showToastMessage(TOAST_TYPE.SUCCESS, response?.data?.message);
    callback();
  } catch (error: any) {
    showToastMessage(
      TOAST_TYPE.ERROR,
      error?.response?.data?.message ?? error?.message
    );
  } finally {
    handleLoading(false);
  }
};

export const unSaveProject = async (
  projectId: string,
  handleLoading: CallableFunction,
  callback: CallableFunction
) => {
  try {
    await API.delete(`${CUSTOMER_PROJECT_ROUTES.UNSAVE_PROJECT}/${projectId}`);
    callback();
  } catch (error: any) {
    showToastMessage(
      TOAST_TYPE.ERROR,
      error?.response?.data?.message ?? error?.message
    );
  } finally {
    handleLoading(false);
  }
};

export const getSavedProjects = async (
  handleData: CallableFunction,
  handleLoading: CallableFunction,
  page: number = 1,
  limit: number = 10,
  searchQuery: string = "",
  sortField: string = "",
  sortOrder: string = ""
) => {
  try {
    const response = await API.get(
      `${CUSTOMER_PROJECT_ROUTES.SAVED_PROJECTS}?page=${page}&limit=${limit}&searchQuery=${searchQuery}&sortField=${sortField}&sortOrder=${sortOrder}`
    );
    handleData(response?.data?.data);
  } catch (error: any) {
    showToastMessage(
      TOAST_TYPE.ERROR,
      error?.response?.data?.message ?? error?.message
    );
  } finally {
    handleLoading(false);
  }
};

export const relatedProperties = async (
  projectId: string,
  handleData: CallableFunction,
  handleLoading: CallableFunction
) => {
  try {
    const response = await API.get(
      `${CUSTOMER_PROJECT_ROUTES.RELATED_PROPERTIES}/${projectId}`
    );
    handleData(response?.data?.data);
  } catch (error: any) {
    showToastMessage(
      TOAST_TYPE.ERROR,
      error?.response?.data?.message ?? error?.message
    );
  } finally {
    handleLoading(false);
  }
};

export const changeImageCaption = async (
  projectId: string,
  data: any,
  handleLoading: CallableFunction
) => {
  try {
    await API.put(
      `${CUSTOMER_PROJECT_ROUTES.PROJECT_IMAGES}/${projectId}`,
      data
    );
  } catch (error: any) {
    showToastMessage(
      TOAST_TYPE.ERROR,
      error?.response?.data?.message ?? error?.message
    );
  } finally {
    handleLoading(false);
  }
};

export const changeImagePosition = async (
  projectId: string,
  data: { image_id: string; new_position: number }
) => {
  try {
    await API.put(
      `${CUSTOMER_PROJECT_ROUTES.PROJECT_IMAGE_POSITION}/${projectId}`,
      data
    );
  } catch (error: any) {
    showToastMessage(
      TOAST_TYPE.ERROR,
      error?.response?.data?.message ?? error?.message
    );
  }
};

export const deleteImagesByProjectId = async (
  handleLoading: CallableFunction,
  projectId: string,
  images: string[]
) => {
  try {
    await API.delete(
      `${CUSTOMER_PROJECT_ROUTES.PROJECT_IMAGES}/delete/${projectId}`,
      {
        data: { images },
      }
    );
  } catch (error: any) {
    showToastMessage(
      TOAST_TYPE.ERROR,
      error?.response?.data?.message ?? error?.message
    );
  } finally {
    handleLoading(false);
  }
};
